import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api } from '../../app/api'

export const fetchDocuments = createAsyncThunk(
    'documents/fetchDocuments',
    async () => {
        // api.defaults.headers = {
        //     Authorization: `Bearer ${localStorage.getItem('token')}`
        // }
        const response = await api.get(`/documents`)
        return response.data
    }
)

const documentsSlice = createSlice({
    name: 'documents',
    initialState: {
        isLoaded: false,
        documents: [],
        error: {
            failed: false,
            message: null,
        },
    },
    extraReducers: {
        [fetchDocuments.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchDocuments.fulfilled]: (state, action) => {
            state.documents = action.payload
            state.isLoaded = true;
        },
        [fetchDocuments.rejected]: (state, action) => {
            state.isLoaded = true;
            state.error.message = action.payload;
            state.error.failed = true;
        },
    }
})

export default documentsSlice.reducer
